import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col,Container, Form, Row, Image, Table, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import LeftSideNavigation from "../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { get_vendor_statement } from "../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import PropTypes from "prop-types";
import { connect, useDispatch,useSelector } from "react-redux";
import {
  SINGLE_VENDOR_SETTLEMENT,
  SINGLE_VENDOR_STATEMENT,
} from "../../../store/types";
import SelectFilter from "../../reusableComponents/selectFilter";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import {
    get_subscription_details,
    admin_payout_vendor,
    get_merchant_statement,
  } from "../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import isEmpty from "../../../store/validation/is-Empty";
import { SmallLoader } from "../../Loader/SmallLoader";
import { Menu, MenuItem } from "@material-ui/core";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import NoContent from "../../reusableComponents/NoContentComponent";

const SingleMerchantStatement = (props) => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().subtract(30, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const [dateQuery, setDateQuery] = useState({});

  const statement = useSelector(state => state.superadminManageTransactions.single_vendor_statement);
  let filteredData = { ...statement };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  const onSuccess = () => {
    setLoading(false);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      setLoading(true);
      const token = props.auth.user.accessToken;
      props.get_merchant_statement(
        token,
        props?.vendorAccess?.vendor_id || props?.auth.user?.VendorUser?._id,
        dateQuery.startDate || '2021-10-20',
        dateQuery.endDate || '2021-11-02',
        onSuccess
      );
    }
  }, [dateQuery]);

  return (
    <React.Fragment>
    <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
      <Row>
        <div className="left-side-panel">
          <LeftSideNavigation />
        </div>
        <div className="top-panel">
          <TopNavigationBarMobile displayLeft="logo" />
        </div>
        <div className="right-side-panel">
          <RightSideNavigation />
          <div className="super-admin-inside-right-side-panel">
            <div className="col-12 ">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                 Merchant Statement
                  <br />
                </div>
                <div>
                  <div
                    align="right"
                    style={{ color: "#9E9E9E" }}
                    className="f10-400 my-2"
                  >
                    Report Run Date: {moment().format("Do MMM, YYYY")}
                  </div>
                  <span
                    className="f12-400 text-grey"
                    style={{ color: "#9E9E9E" }}
                  >
                    Report Range Date:
                  </span>
                  <span className="f12-500">
                    {" "}
                    {moment(dateQuery?.startDate).format("Do MMM, YYYY")} {"-"}{" "}
                    {moment(dateQuery?.endDate).format("Do MMM, YYYY")}
                  </span>
                </div>
              </div>
              <Row>
                <Col md={3}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div
                      className="f10-400"
                      align="center"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                    //  onClick={() => setShowSearch(!showsearch)}
                    >
                      <Image
                        alt="filter"
                        title="filter"
                        width="80px"
                        src={require("../../../assets/images/iconButton/newsearchicon.svg")}
                      />
                    </div>
                    <div
                      className="f10-400"
                      align="center"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                    //  onClick={handleClick}
                    >
                      <img
                        src={require("../../../assets/images/iconButton/sortbtn.svg")}
                        width="80px"
                        alt="sorticon"
                      />
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/filterbtn.svg")}
                        width="80px"
                        alt="Filter Icon"
                    //    onClick={() => setShowFilter(!showFilter)}
                      />
                    </div>
                    <div className="f10-400" align="center">
                    <img
                        src={require("../../../assets/images/iconButton/downloadbtn.svg")}
                        width="80px"
                        alt="icon"
                        title="Download"
                    />
                    </div>
                  </div>
                </Col>
                <Col md={6}></Col>
                <div className="col-3 d-flex justify-content-end">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
              </Row>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                  <Table>
                    <thead>
                      <TableHead />
                    </thead>
                    {loading ? (
                      <SmallLoader />
                    ) : (
                      <>
                            <TableBody
                            data={props?.data}
                              startDate={startDate}
                              endDate={endDate}
                            />     
                      </>
                    )}
                  </Table>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    data: state.superadminManageTransactions.single_vendor_statement,
    vendorAccess: state.vendorAccess
  });
  
  export default connect(mapStateToProps, {
    get_merchant_statement
  })(SingleMerchantStatement);

const TableHead = (props) => {
  return (
    <tr>
      <td style={{ width: "12%" }} className="f12-400">
        Net Order <br /> Value
      </td>
      <td style={{ width: "12%" }} className="f12-400">
        Net Events <br /> Value
      </td>
      <td style={{ width: "12%" }} className="f12-400">
        Net Scan & <br /> Pay Value
      </td>
      <td style={{ width: "12%" }} className="f12-400">
        Net Tip <br /> Value
      </td>
      <td style={{ width: "12%" }} className="f12-400">
        Referral <br /> Credit
      </td>
      <td style={{ width: "12%" }} className="f12-400">
      Amealio  <br /> Commission
      </td>
      <td style={{ width: "12%" }} className="f12-400">
        Total <br /> Amount
      </td>
     
      <td style={{ width: "15%" }} className="f12-400">Actions</td>
    </tr>
  );
};

const TableBody = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const redirectMerchant = () => {
    history.push(`/merchantStatement`);
  };

  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr>
               
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.totalOrder?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.totalEvent?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.totalScan?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.totalTip?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.totalReward?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ 0
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.total?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div
                    className="f12-500 badge p-2"
                    style={{
                      backgroundColor: "#ee3a23",
                      color: "white",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      redirectMerchant()
                    }
                  >
                    View Statement
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
